import React from 'react';
import PropTypes from 'prop-types';

const DropdownItem = ({image, value, className, setSelectedValues = () => {}, setUserLocation= () => {}}) => {

  return (
    <li className={`${className.background ? className.background : ''}`} onClick={() => {setUserLocation(value)}}>
        <img src={image}/>
        <h3 className={`${className.text ? className.text : ''}`}>{value}</h3>
    </li>
  )
}

DropdownItem.propTypes = {
    value: PropTypes.string,
    image: PropTypes.string,
    className: PropTypes.object,
    setSelectedValues: PropTypes.func

  };

export default DropdownItem